import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/apiClient';
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
export const API_BASE = 'designmanager/v1/themes/by-path';
const THEME_EARLY_REQUEST_NAME = 'theme';
export const fetchThemeAndSettings = (themePath, variantName) => {
  const earlyRequest = quickFetch.getRequestStateByName(THEME_EARLY_REQUEST_NAME);
  const variantQuery = variantName ? `?variantName=${variantName}` : '';
  const themeSettingsPath = Routes.isUngated(gate('ThemesAndModules:ThemeSettingsChirpMigration')) ? 'with-settings' : 'settings';
  const themeApiPath = `${API_BASE}/${themePath}/${themeSettingsPath}${variantQuery}`;
  const fetchData = () => http.get(themeApiPath);
  let resultPromise;
  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(THEME_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError(() => {
        fetchData().then(resolve, reject).catch(err => console.error(err));
        quickFetch.removeEarlyRequest(THEME_EARLY_REQUEST_NAME);
      });
    });
  } else {
    resultPromise = fetchData();
  }
  return resultPromise;
};